export default {
  catalog_id_placeholder: '№ ',
  country: 'Land',
  region: 'Region',
  city: 'Stadt',
  district: 'Stadtteil',
  category: 'Kategorie',
  type: 'Typ',
  subtype: 'Subtyp',
  purpose: 'Transaktionsart',
  any: 'Beliebig',
  apply: 'Anwenden',
  reset: 'Zurücksetzen',
  show: 'Filter anzeigen',
  hide: 'Filter ausblenden',

  purpose_options: {
    sale: 'Verkauf',
    rental: 'Langzeitmiete',
    daily_rent: 'Kurzzeitmiete',
    investment: 'Investition',
    holiday: 'Ferien / Urlaub',
    commercial_use: 'Gewerbliche Nutzung',
    residence: 'Wohnnutzung'
  }

}
